import { TargetBoneMappingType } from '../steps/StepBoneMapping'

export type MappingConfidenceLevel = 'exact' | 'vendor' | 'manual' | 'heuristic'

export interface MappingConfidenceResult {
  level: MappingConfidenceLevel
  label: string
  description: string
}

export class MappingConfidence {
  static evaluate (
    target_bone_name: string,
    source_bone_name: string,
    mapping_type: TargetBoneMappingType
  ): MappingConfidenceResult {
    if (mapping_type === TargetBoneMappingType.Mesh2Motion || target_bone_name === source_bone_name) {
      return {
        level: 'exact',
        label: 'Exact',
        description: 'Target and source bone names match directly.'
      }
    }

    if (
      mapping_type === TargetBoneMappingType.Mixamo ||
      mapping_type === TargetBoneMappingType.Tripo ||
      mapping_type === TargetBoneMappingType.UniversalHumanoid
    ) {
      return {
        level: 'vendor',
        label: 'Profile',
        description: `Mapped through the ${this.mapping_type_label(mapping_type)} profile.`
      }
    }

    if (mapping_type === TargetBoneMappingType.Custom) {
      return {
        level: 'manual',
        label: 'Custom',
        description: 'Mapped manually or by fallback name/category matching.'
      }
    }

    return {
      level: 'heuristic',
      label: 'Check',
      description: 'Mapping source is unknown; verify this bone before export.'
    }
  }

  private static mapping_type_label (mapping_type: TargetBoneMappingType): string {
    switch (mapping_type) {
      case TargetBoneMappingType.Mixamo:
        return 'Mixamo'
      case TargetBoneMappingType.Tripo:
        return 'Tripo3D'
      case TargetBoneMappingType.UniversalHumanoid:
        return 'Universal Humanoid'
      case TargetBoneMappingType.Mesh2Motion:
        return 'Meshinator'
      default:
        return 'Custom'
    }
  }
}
